export default __webpack_public_path__ + "static/Wideangle_Lense_2.9mm_Angle_of_View-fff4dd69870a17575977725eb0e63cef.webp";